const stDesk = {
  containMsgGestor: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '0 0 0 10px',
    height: 'auto',
    width: '100%',
  },
  containGestor: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: 'auto',
    minWidth: '300px',
    padding: '5px',
    margin: '5px 0px',
    backgroundColor: '#FF7043',
    borderRadius: '15px 0px',
  },

  containMsgUser: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 10px 0 0',
    margin: '5px 0',
    height: 'auto',
    width: '100%',
  },

  titleGestor: {
    width: '100%',
    textAlign: 'left',
    color: 'white',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  textoMsg: {
    width: '100%',
    textAlign: 'left',
    color: 'white',
    fontSize: '16px',
  },

  containDataCheck: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
  },
  labelData: {
    fontSize: '12px',
    color: '#9E9E9E',
  },

  containUsuario: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: 'auto',
    padding: '5px',
    backgroundColor: '#d9d9d9',
    borderRadius: '0px 15px',
    margin: '5px 0px',
  },
}

const stMob = {}

export { stDesk, stMob }
